<script>
  // lib
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();
</script>

<header>
  <h1 on:click={() => dispatch("tabChange", "Current Polls")}>My Polls</h1>
</header>

<style>
  header {
    margin: 0 0 0 0;
  }
  h1 {
    margin: 0;
    font-weight: 600;
    font-size: 1.8em;
    cursor: pointer;
  }
  @media (min-width: 576px) {
    h1 {
      font-size: 1.8em;
    }
  }
</style>
